import { H2, H4, Icon } from '@blueprintjs/core';
import { IconNames } from '@blueprintjs/icons';
import { AddLarge, Login } from '@carbon/icons-react';
import * as React from 'react';
import { Button } from 'vet-bones/design-system/components';

import { useAppDispatch } from 'src/ui/app/hooks';
import {
  LAUNCHPAD_ADD_BASIC_CONNECTION_BUTTON,
  LAUNCHPAD_ADD_SSO_CONNECTION_BUTTON,
} from 'src/ui/constants/testIds';
import { Welcome } from 'src/ui/containers/landing/Welcome';
import { DialogType, openedDialog } from 'src/ui/features/ui';
import { useVersion } from 'src/ui/hooks/version';
import * as copy from 'src/ui/templates/copy';

export const NewUserLanding: React.VFC = () => {
  const dispatch = useAppDispatch();
  const { data: versionData } = useVersion();

  const handleAddConnection = () =>
    dispatch(openedDialog({ type: DialogType.ADD_ENDPOINT }));
  const handleAddSSOConnection = () =>
    dispatch(openedDialog({ type: DialogType.ADD_SSO_ENDPOINT }));

  const subText = versionData?.version ? (
    <span className="version-text">v{versionData.version}</span>
  ) : (
    ''
  );

  return (
    <>
      <Welcome
        className="welcome-container-voicebox"
        subText={subText}
        titleText={copy.components.launchpad.dashboard.title}
      />
      <div className="sd-landing-new-user-launchpad">
        <Icon icon={IconNames.OFFLINE} size={80} />
        <H2>{copy.components.launchpad.emptyState.title}</H2>
        <div className="sd-landing-new-user-actions">
          <H4>{copy.components.launchpad.emptyState.description}</H4>
          <div className="new-connection-section">
            <Button
              leftIcon={AddLarge}
              onClick={handleAddConnection}
              size="md"
              testId={LAUNCHPAD_ADD_BASIC_CONNECTION_BUTTON}
              variant="tertiary-accent"
            >
              {copy.components.launchpad.connections.addBasic}
            </Button>
            <Button
              leftIcon={Login}
              onClick={handleAddSSOConnection}
              size="md"
              testId={LAUNCHPAD_ADD_SSO_CONNECTION_BUTTON}
              variant="tertiary-accent"
            >
              {copy.components.launchpad.connections.addSso}
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};
